import * as Yup from 'yup';

export const formValidationSchema = Yup.object().shape({
  tgl_realisasi_petty_cash: Yup.string().required(
    'Pilih Tanggal Realisasi Petty Cash'
  ),
});
